import { Injectable } from '@angular/core';
import { CurrencyInterface } from '@app/shared/services/currency/currency.interface';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';

const DEFAULT_CURRENCY: { name: string; symbol: string } = {
  name: 'GBP',
  symbol: '£',
};

@Injectable()
export class CurrencyService {
  public get currencyName(): string {
    if (!this._currencyName) {
      this.loadUserCurrency().then(() => {
        return this._currencyName;
      });
    }
    return this._currencyName;
  }

  public set currencyName(value: string) {
    this._currencyName = value;
    this.localStorageService.setCurrencyName(this._currencyName);
  }

  public get clientCurrencyName(): string {
    if (!this._clientCurrencyName) {
      this.loadUserCurrency().then(() => {
        return this._currencyName;
      });
    }
    return this._clientCurrencyName;
  }

  public set clientCurrencyName(value: string) {
    this._clientCurrencyName = value;
    this.localStorageService.setClientCurrencyName(this._clientCurrencyName);
  }

  public get currencySymbol(): string {
    if (!this._currencySymbol) {
      this.loadUserCurrency().then(() => {
        return this._currencySymbol;
      });
    }
    return this._currencySymbol;
  }

  public set currencySymbol(value: string) {
    this._currencySymbol = value;
    this.localStorageService.setCurrencySymbol(this._currencySymbol);
  }

  public get clientCurrencySymbol(): string {
    if (!this._clientCurrencySymbol) {
      this.loadUserCurrency().then(() => {
        return this._currencySymbol;
      });
    }
    return this._clientCurrencySymbol;
  }

  public set clientCurrencySymbol(value: string) {
    this._clientCurrencySymbol = value;
    this.localStorageService.setClientCurrencySymbol(this._clientCurrencySymbol);
  }

  private _currencyName: string;
  private _currencySymbol: string;

  private _clientCurrencyName: string;
  private _clientCurrencySymbol: string;

  constructor(
    private readonly localStorageService: LocalStorageService,
  ) {
  }

  public async loadUserCurrency(): Promise<void> {
    const currencyName = this.localStorageService.getCurrencyName();
    const currencySymbol = this.localStorageService.getCurrencySymbol();
    if (!currencyName || !currencySymbol) {
      const config: CurrencyInterface = {} as CurrencyInterface;
      this._currencyName = config && config.name ? config.name : DEFAULT_CURRENCY.name;
      this._currencySymbol = config && config.symbol ? config.symbol : DEFAULT_CURRENCY.symbol;
    } else {
      this._currencyName = currencyName;
      this._currencySymbol = currencySymbol;
    }
  }
}
